import { type OnDestroy, type OnInit, Component, inject } from '@angular/core';
import {Subscription} from 'rxjs';
import {FirebaseService} from '../../../core/services/firebase.service';


@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: []
})
export class FooterComponent implements OnInit, OnDestroy {
  private firebaseService = inject(FirebaseService);

  openingHours: Record<string, unknown>[] = [];
  subscriptions: Subscription = new Subscription();

  ngOnInit() {
    this.subscriptions.add(
        this.firebaseService.getOpeningHours().subscribe(data => {
            this.openingHours = [];
            this.openingHours = data?.map(x => x.data());
            this.openingHours.sort((a, b) => (a.sortOrder as number) - (b.sortOrder as number));
        }));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

}
